import { useMutation } from '@tanstack/react-query';
import {
  TransferWithEvidenceService,
  CreateTransferRequestDto,
  CreateTransferRequestEntity,
} from 'services/openapi';

export const useCreateTransferRequestMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<CreateTransferRequestEntity, Error, CreateTransferRequestDto>({
      mutationFn: (variables: CreateTransferRequestDto) =>
        TransferWithEvidenceService.transferWithEvidenceControllerCreate(
          variables,
        ),
    });

  return { isLoading, isSuccess, error, data, isError, mutate, mutateAsync };
};
